import React, { useState } from 'react';
import { Star } from './Star';
import { useLightSwitchesAudioEffect } from '../audio-effect/useLightSwitchesAudioEffect';

interface Props {
  onChange: (value: number) => void;
  name: string;
}

export const Stars = ({ onChange, name }: Props) => {
  const [value, setValue] = useState<number>(0);
  const [playAudioEffect] = useLightSwitchesAudioEffect();

  return (
    <div>
      {[1, 2, 3, 4, 5].map(v => (
        <Star
          key={v}
          value={v}
          name={name}
          active={value >= v}
          onChange={e => {
            try {
              playAudioEffect();
            } catch (error) {
              // Silently ignore audio effect errors
            }
            const newValue = parseInt(e.target.value);
            setValue(newValue);
            onChange(newValue);
          }}
        />
      ))}
    </div>
  );
};
